import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, XCircle, Lock, Zap, Download, Star } from 'lucide-react';
import { DigitalDisclaimer } from './DigitalDisclaimer';
export function SistemaCompleto() {
  const benefits = ['Curso completo Amazon FBA', 'Curso completo Amazon FBM', 'Estrategias para combinar ambos modelos', 'Todos los Bonos Premium incluidos', 'Acceso inmediato', 'Actualizaciones futuras'];
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026', '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-beige py-16 md:py-24 px-4 sm:px-6 relative overflow-hidden" data-id="element-666">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-667">
        {/* Header */}
        <FadeIn data-id="element-668">
          <div className="text-center mb-10 md:mb-12" data-id="element-669">
            <div className="inline-flex items-center justify-center gap-2 bg-brand-green text-white rounded-full px-5 py-2 mb-6 shadow-sm" data-id="element-670">
              <span className="text-xs sm:text-sm font-bold tracking-[0.15em] uppercase" data-id="element-671">
                🔥 La opción que más eligen nuestros estudiantes
              </span>
            </div>

            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green mb-5 leading-[1.05] tracking-tight" data-id="element-672">
              SISTEMA COMPLETO AMAZON FBA + FBM
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-brand-text/70 max-w-2xl mx-auto leading-relaxed" data-id="element-673">
              Aprende los dos modelos de negocio más importantes de Amazon con
              un solo sistema y ahorra dinero frente a comprarlos por separado.
            </p>
          </div>
        </FadeIn>

        {/* Main premium card */}
        <FadeIn delay={0.1} data-id="element-674">
          <div className="bg-white rounded-3xl p-6 sm:p-10 md:p-12 shadow-[0_20px_60px_-25px_rgba(28,57,40,0.25)] border border-brand-text/10" data-id="element-675">
            {/* Gold best-seller label */}
            <div className="flex justify-center mb-8" data-id="element-676">
              <span className="inline-flex items-center gap-1.5 bg-brand-gold text-brand-green font-bold text-xs sm:text-sm uppercase tracking-[0.15em] px-5 py-2 rounded-full shadow-sm" data-id="element-677">
                <Star className="w-3.5 h-3.5 fill-brand-green" data-id="element-678" />
                Producto más vendido
              </span>
            </div>

            {/* PRODUCT IMAGE — dominant visual element */}
            <div className="flex justify-center mb-10 md:mb-12" data-id="element-679">
              <img src="https://cdn.magicpatterns.com/uploads/bVeZufEQYHHUtcgss4qahy/ChatGPT_Image_25_jun_2026,_16_30_13.png" alt="Sistema Completo Amazon FBA + FBM — los dos cursos completos" className="w-[90%] h-auto md:h-[460px] md:w-auto md:max-w-[90%] object-contain rounded-[20px] shadow-[0_24px_60px_-18px_rgba(0,0,0,0.28)]" data-id="element-680" />
            </div>

            {/* Pre-price eyebrow */}
            <p className="text-center text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-brand-text/55 mb-5" data-id="element-681">
              Todo lo que recibes en un solo pago
            </p>

            {/* SAVINGS BOX — the visual hero of the section */}
            <div className="bg-brand-beige/60 border border-brand-gold/30 rounded-2xl px-6 py-8 sm:px-10 mb-6 text-center" data-id="element-682">
              <p className="text-xs uppercase tracking-[0.2em] text-brand-text/50 font-semibold mb-1" data-id="element-683">
                Valor total del contenido
              </p>
              <p className="text-2xl sm:text-3xl font-bold text-brand-text/50 line-through mb-5" data-id="element-684">
                $32.98
              </p>

              <p className="text-xs uppercase tracking-[0.2em] text-brand-text/50 font-semibold mb-1" data-id="element-685">
                Hoy pagas
              </p>
              <p className="text-5xl sm:text-6xl font-bold text-brand-green tracking-tight leading-none mb-6" data-id="element-686">
                $24.99
              </p>

              {/* AHORRAS — biggest visual element */}
              <div className="inline-flex items-center justify-center gap-2 bg-brand-green rounded-2xl px-6 sm:px-10 py-4 shadow-lg max-w-full" data-id="element-687">
                <span className="text-base sm:text-xl md:text-2xl font-bold text-white leading-tight" data-id="element-688">
                  🟢 AHORRAS <span className="text-brand-gold" data-id="element-689">$7.99</span> AL
                  COMPRAR EL PAQUETE COMPLETO
                </span>
              </div>
            </div>

            {/* Value reassurance box */}
            <div className="bg-brand-green/5 border border-brand-green/20 rounded-2xl px-6 py-5 mb-10 text-center" data-id="element-690">
              <p className="text-sm sm:text-base text-brand-text/80 leading-relaxed" data-id="element-691">
                Obtienes{' '}
                <span className="font-semibold text-brand-green" data-id="element-692">
                  dos cursos completos
                </span>
                , todos los bonos Premium y futuras actualizaciones por menos de
                lo que cuesta comprarlos por separado.
              </p>
            </div>

            {/* Benefits — more breathing room */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6 mb-12 max-w-2xl mx-auto" data-id="element-693">
              {benefits.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-694">
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-695" />
                  <span className="text-base text-brand-text/85 font-medium leading-snug" data-id="element-696">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* CTA — bold dark green button */}
            <div className="flex flex-col items-center" data-id="element-697">
              <Button onClick={goToCheckout} className="w-full max-w-lg bg-brand-green hover:bg-brand-green/90 text-white text-lg md:text-2xl font-bold px-8 py-7 shadow-2xl shadow-brand-green/40 ring-2 ring-brand-gold/40 tracking-wide transition-transform duration-200 hover:scale-[1.02]" data-id="element-698">
                QUIERO EL SISTEMA COMPLETO
              </Button>
              <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-brand-text/55 text-xs mt-5" data-id="element-699">
                <span className="flex items-center gap-1.5" data-id="element-700">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-701" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-702">
                  <Lock className="w-3.5 h-3.5 text-brand-green" data-id="element-703" />
                  PAGO 100% SEGURO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-704">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-705" />
                  DESCARGA INSTANTÁNEA
                </span>
              </div>
            </div>

            {/* Social proof */}
            <p className="text-center text-sm sm:text-base text-brand-text/65 leading-relaxed max-w-xl mx-auto mt-8" data-id="element-706">
              Miles de emprendedores comienzan comprando un solo curso. La
              mayoría termina necesitando ambos. Por eso este paquete es el
              favorito de quienes quieren{' '}
              <span className="font-semibold text-brand-green" data-id="element-707">
                ahorrar dinero desde el principio.
              </span>
            </p>

            <DigitalDisclaimer variant="dark" data-id="element-708" />
          </div>
        </FadeIn>

        {/* Visual comparison */}
        <FadeIn delay={0.15} data-id="element-709">
          <div className="mt-12" data-id="element-710">
            <h3 className="font-serif text-2xl sm:text-3xl font-bold text-brand-green text-center mb-8 tracking-tight" data-id="element-711">
              ¿Por qué la mayoría elige el Sistema Completo?
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6" data-id="element-712">
              {/* Comprar por separado */}
              <div className="bg-white rounded-2xl p-6 sm:p-8 border border-brand-text/10" data-id="element-713">
                <h4 className="text-lg font-bold text-brand-text/70 mb-5 text-center" data-id="element-714">
                  Comprar por separado
                </h4>
                <ul className="space-y-3" data-id="element-715">
                  {['Dos pagos', 'Mayor inversión', 'Debes regresar más adelante por el otro curso'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-716">
                      <XCircle className="w-5 h-5 text-brand-text/40 flex-shrink-0 mt-0.5" data-id="element-717" />
                      <span className="text-brand-text/60" data-id="element-718">{item}</span>
                    </li>)}
                </ul>
              </div>

              {/* Sistema Completo — highlighted */}
              <div className="bg-brand-green/5 rounded-2xl p-6 sm:p-8 border-2 border-brand-green/40 shadow-sm" data-id="element-719">
                <h4 className="text-lg font-bold text-brand-green mb-5 text-center" data-id="element-720">
                  Sistema Completo
                </h4>
                <ul className="space-y-3" data-id="element-721">
                  {['Un solo pago', 'Ahorras $7.99', 'Recibes ambos sistemas desde el primer día'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-722">
                      <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-723" />
                      <span className="text-brand-text/85 font-medium" data-id="element-724">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}